var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventRefresh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AB6E3BD2-3CA1-4C29-80B1-2CF345C9437F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-26.2%",
    y: "-26.2%",
    width: "152.5%",
    height: "152.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.75,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.520003929   0 0 0 0 0.803309895   0 0 0 0 0.859629755  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Components:-Filters",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset-Refresh-Data->-Default->-In-Progress",
    transform: "translate(-198.000000, -163.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(202.000000, 167.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#2A323B",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.6984425,6.30059524 C12.748444,5.35119048 11.4446529,4.76190476 9.99672414,4.76190476 C7.10086661,4.76190476 4.76190476,7.10595238 4.76190476,10 C4.76190476,12.8940476 7.10086661,15.2380952 9.99672414,15.2380952 C12.4405134,15.2380952 14.4780964,13.5684524 15.061199,11.3095238 L13.6984425,11.3095238 C13.1612019,12.835119 11.7067215,13.9285714 9.99672414,13.9285714 C7.82810685,13.9285714 6.06569582,12.1672619 6.06569582,10 C6.06569582,7.8327381 7.82810685,6.07142857 9.99672414,6.07142857 C11.0843086,6.07142857 12.0539623,6.52321429 12.7615474,7.23690476 L10.6518955,9.3452381 L15.2380952,9.3452381 L15.2380952,4.76190476 L13.6984425,6.30059524 Z",
    id: "Path-Copy",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventRefresh);
export default __webpack_public_path__ + "static/media/event-refresh.e5f011c7bbf59dc36e6d8e2a02110bb2.svg";
export { ForwardRef as ReactComponent };